import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms19x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hrms19x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dtestrt = ''
    let dteend = ''
    if (typeof searchParams !== 'undefined') {
      dtestrt = (typeof searchParams.dtestrt !== 'undefined' ? searchParams.dtestrt : dtestrt)
      dteend = (typeof searchParams.dteend !== 'undefined' ? searchParams.dteend : dteend)
      sendParams = {
        p_codempid_query: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : ''),
        p_codcomp: (typeof searchParams.codcomp2 !== 'undefined' ? searchParams.codcomp2 : ''),
        p_codcalen: (typeof searchParams.codcalen !== 'undefined' ? searchParams.codcalen : '')
      }
    }
    return instance().get(endpoint + '/hrms19x/index/' + dtestrt.replace(/\//g, '') + '/' + dteend.replace(/\//g, ''), { params: sendParams })
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms19x/index.js